import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../authContext';
import AppVersion from './AppVersion';

function ProtectedRoute({ children, blockRoles = [], requireManager = false, redirectTo = '/hub' }) {
  const { user, level, isManager } = useContext(AuthContext);

  let content = <Navigate to="/login" />;
  if (user) {
    // Bloqueia roles específicas (ex.: usuário "externo" não acessa área de
    // moderador nem criação/configuração de assistente) redirecionando em
    // vez de derrubar a sessão.
    if (blockRoles.includes(level)) {
      content = <Navigate to={redirectTo} />;
    } else if (requireManager && !isManager) {
      // Feature Gestão de Grupos (FR-003): rota só acessível a is_manager=true.
      content = <Navigate to={redirectTo} />;
    } else {
      content = children;
    }
  }

  return (
    <>
      {content}
      <AppVersion /> {/* ✅ sempre renderiza a versão ao fundo */}
    </>
  );
}

export default ProtectedRoute;
